import * as React from "react";
const SvgSword = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M21.725 2.038a1 1 0 0 1 1.237 1.236l-.147.51a13 13 0 0 1-3.306 5.622L16.414 12.5l2.086 2.086.793-.793a1 1 0 0 1 1.414 1.414l-1.493 1.491-.007.009-.546.545.046.04 4 4a1 1 0 1 1-1.414 1.415l-4-4q-.022-.022-.041-.046l-.545.546-.009.007-1.491 1.493a1 1 0 1 1-1.414-1.414l.793-.793-2.086-2.086-2.086 2.086.793.793a1 1 0 1 1-1.414 1.414L7.747 18.66l-.04.046-4 4a1 1 0 1 1-1.414-1.414l4-4q.022-.022.045-.041l-2.045-2.045a1 1 0 0 1 1.414-1.414l.792.792 2.086-2.086L5.49 9.406a13 13 0 0 1-3.307-5.621l-.146-.51a1 1 0 0 1 1.236-1.237l.51.146a13 13 0 0 1 5.622 3.307l3.093 3.094 3.095-3.094a13 13 0 0 1 5.62-3.307zM13.914 15 16 17.086 17.086 16 15 13.914zm6.491-10.406a11 11 0 0 0-3.396 2.312L7.915 16 9 17.085l9.093-9.094c.98-.98 1.763-2.133 2.312-3.397m-15.81 0a11 11 0 0 0 2.311 3.397l3.093 3.094 1.086-1.086L7.99 6.906a11 11 0 0 0-3.397-2.312",
  clipRule: "evenodd"
}));
export default SvgSword;
//# sourceMappingURL=Sword.js.map